import { StyledPageWrapper } from 'components/fragments/PageWrapper/styled';
import ToolSidebar from 'components/fragments/ToolSidebar/ToolSidebar';
import { useState } from 'react';
import { CopyIprIdToQaRequest } from 'models/apiModels';
import { SubmitHandler, useForm } from 'react-hook-form';
import { usePostCopyIprIdToQaRequestMutation } from 'store/api/tools-v1';
import { createRoleAccessChecker } from 'utils/userRolesUtils/userRolesUtils';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAppSelector } from 'hooks/hooks';
import ReactJson from 'react-json-view';
import { StyledCopyIprIdToQaPresentation } from './styled';
import { CopyIprIdToQaForm, FormInput } from './CopyIprIdToQaForm';
import { roles } from '../../constants';

export const CopyIprIdToQaPage = () => {
  const { role } = useAppSelector((state) => state.auth.session);
  const location = useLocation();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const paramIprId = searchParams.get('iprId') ?? undefined;
  const [iprId, setIprId] = useState<string | undefined>(paramIprId);

  if (role === roles.Unauthorized || !createRoleAccessChecker(role)(location.pathname)) {
    navigate('/', { replace: true });
  }
  const [sendCopyIprIdRequest, { data, error: queryError, isLoading, isSuccess }] =
    usePostCopyIprIdToQaRequestMutation();

  const onSubmit: SubmitHandler<FormInput> = (formData) => {
    const oldParams = Object.fromEntries(searchParams);
    const params = { ...oldParams, iprId: formData.iprId };
    setSearchParams(params, { replace: true });
    setIprId(formData.iprId);

    const copyIprIdToQa: CopyIprIdToQaRequest = { iprId: formData.iprId };

    sendCopyIprIdRequest(copyIprIdToQa);
  };

  const {
    register,
    handleSubmit,
    formState: { errors: formErrors },
  } = useForm<FormInput>({
    defaultValues: {
      iprId: iprId ?? '',
    },
  });
  return (
    <>
      <ToolSidebar>
        <CopyIprIdToQaForm
          onSubmit={handleSubmit(onSubmit)}
          register={register}
          errors={formErrors}
        />
      </ToolSidebar>
      <StyledPageWrapper>
        <StyledCopyIprIdToQaPresentation>
          <h1>Copy Ipr Id to QA </h1>
          {isLoading && <h3>Loading...</h3>}
          {queryError && !isSuccess && <h2> Failed to execute request</h2>}
          {!queryError && isSuccess && data && (
            <>
              <h3> Ipr Id copied to QA</h3>
              <ReactJson src={data} displayObjectSize={false} collapsed={1} name={false} />
            </>
          )}
          <hr />
          <h4> Instructions: </h4>
          <p>
            Enter the Ipr Id of the mower for which you want to copy the Ipr Id from live to QA.
          </p>
        </StyledCopyIprIdToQaPresentation>
      </StyledPageWrapper>
    </>
  );
};
